import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-[var(--bg-section)] py-8">
        <div className="container">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors mb-6"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
          <h1 className="heading-2">Terms of Service</h1>
          <p className="text-[var(--text-secondary)] mt-2">Last updated: January 2025</p>
        </div>
      </div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="container py-12 max-w-4xl"
      >
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="heading-3 mb-4">1. Agreement to Terms</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              By accessing or using the Happiness in Action website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">2. Services</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              Happiness in Action provides digital transformation consultancy services including website development, Google Workspace migration, AI chatbot implementation, and custom AI agent development for small and medium enterprises.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">3. Client Responsibilities</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              As a client, you agree to:
            </p>
            <ul className="list-disc pl-6 text-[var(--text-body)] space-y-2 mb-4">
              <li>Provide accurate and complete information</li>
              <li>Respond to requests for information in a timely manner</li>
              <li>Make payments according to agreed terms</li>
              <li>Provide necessary access to systems and accounts as required</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">4. Intellectual Property</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              Upon full payment, clients receive full ownership of custom work produced specifically for them. We retain the right to use non-confidential aspects of our work for portfolio and marketing purposes.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">5. Payment Terms</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              Payment terms will be specified in individual project agreements. Typically, we require a deposit before commencing work, with the balance due upon project completion or according to agreed milestones.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">6. Limitation of Liability</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              To the maximum extent permitted by law, Happiness in Action shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">7. Governing Law</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              These Terms shall be governed by and construed in accordance with the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">8. Contact</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              For questions about these Terms, please contact us at:
            </p>
            <p className="text-[var(--text-body)]">
              <strong>Email:</strong> don@happinessinaction.co<br />
              <strong>Phone:</strong> +44 333 011 7974
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
};

export default TermsOfService;
